import {getVaultSize} from "./vault";
import {Plan} from "../../types";

export const getManhole = (plan: Plan) => (plan.lid.manholes.length === 1 ? plan.lid.manholes[0] : null)
const getManholeLeft = (plan: Plan) => (getManhole(plan) ? getManhole(plan)!.x : 0)
const getManholeLength = (plan: Plan) => (getManhole(plan) ? getManhole(plan)!.width : 0)
const getManholeRight = (plan: Plan) => getManholeLeft(plan) + getManholeLength(plan)
const getManholeFront = (plan: Plan) => (getManhole(plan) ? getManhole(plan)!.y : 0)
const getManholeWidth = (plan: Plan) => (getManhole(plan) ? getManhole(plan)!.height : 0)
const getManholeBack = (plan: Plan) => getManholeFront(plan) + getManholeWidth(plan)

const manholeFunctions = {
    getSize: (plan: Plan) => getManhole(plan),
    getLeft: getManholeLeft,
    getLength: getManholeLength,
    getRight: getManholeRight,
    getFront: getManholeFront,
    getWidth: getManholeWidth,
    getBack: getManholeBack,
}

export const supplementaryCoverFunctions = {
    has: (plan: Plan, position: any) => !plan.intermediateCeiling
        && getManhole(plan)
        && (
            position === 'left' && manholeFunctions.getLeft(plan) > getVaultSize(plan, true).clearMeasureLeft ? true
                : position === 'right' && manholeFunctions.getRight(plan) < getVaultSize(plan, true).clearMeasureRight ? true
                    : position === 'front' && manholeFunctions.getFront(plan) > getVaultSize(plan, true).clearMeasureFront ? true
                        : position === 'back' && manholeFunctions.getBack(plan) < getVaultSize(plan, true).clearMeasureBack
        ),
    getSize: (plan: Plan, position: any) => {
        const vaultSize = getVaultSize(plan, true)

        return position === 'left' ? {
                x: vaultSize.left,
                y: vaultSize.front,
                z: 0,
                length: manholeFunctions.getLeft(plan) - vaultSize.left,
                width: vaultSize.width,
                height: 20
            }
            : position === 'right' ? {
                    x: manholeFunctions.getRight(plan),
                    y: vaultSize.front,
                    z: 0,
                    length: vaultSize.right - manholeFunctions.getRight(plan),
                    width: vaultSize.width,
                    height: 20
                }
                : position === 'front' ? {
                        x: vaultSize.left,
                        y: vaultSize.front,
                        z: 0,
                        length: vaultSize.length,
                        width: manholeFunctions.getFront(plan) - vaultSize.front,
                        height: 20
                    }
                    : position === 'back' ? {
                            x: vaultSize.left,
                            y: manholeFunctions.getBack(plan),
                            z: 0,
                            length: vaultSize.length,
                            width: vaultSize.back - manholeFunctions.getBack(plan),
                            height: 20
                        }
                        : {}
    },
    getLeft: (plan: Plan, position: any) => supplementaryCoverFunctions.getSize(plan, position).x,
    getLength: (plan: Plan, position: any) => supplementaryCoverFunctions.getSize(plan, position).length,
    getRight: (plan: Plan, position: any) =>
        (supplementaryCoverFunctions.getLeft(plan, position) ?? 0)
        + (supplementaryCoverFunctions.getLength(plan, position) ?? 0),
    getFront: (plan: Plan, position: any) => supplementaryCoverFunctions.getSize(plan, position).y,
    getWidth: (plan: Plan, position: any) => supplementaryCoverFunctions.getSize(plan, position).width,
    getBack: (plan: Plan, position: any) =>
        (supplementaryCoverFunctions.getFront(plan, position) ?? 0)
        + (supplementaryCoverFunctions.getWidth(plan, position) ?? 0),
    getBottom: (plan: Plan, position: any) => supplementaryCoverFunctions.getSize(plan, position).z,
    getHeight: (plan: Plan, position: any) => supplementaryCoverFunctions.getSize(plan, position).height,
    getTop: (plan: Plan, position: any) =>
        (supplementaryCoverFunctions.getBottom(plan, position) ?? 0)
        + (supplementaryCoverFunctions.getHeight(plan, position) ?? 0)
}

export const hasSupplementaryCoverLeft = (plan: Plan) => supplementaryCoverFunctions.has(plan, 'left')
export const hasSupplementaryCoverRight = (plan: Plan) => supplementaryCoverFunctions.has(plan, 'right')
export const hasSupplementaryCoverFront = (plan: Plan) => supplementaryCoverFunctions.has(plan, 'front')
export const hasSupplementaryCoverBack = (plan: Plan) => supplementaryCoverFunctions.has(plan, 'back')

export const hasSupplementaryCover = (plan: Plan) => {
    return hasSupplementaryCoverLeft(plan) || hasSupplementaryCoverRight(plan)
        || hasSupplementaryCoverFront(plan) || hasSupplementaryCoverBack(plan)
}
